require('../stylesheets/public_hotsites.scss');

require('../pages/public_hotsites/matches.js');
require('../pages/public_hotsites/scores_avg_chart.js');
require('../pages/public_hotsites/competitor_charts.js');
require('../pages/public_hotsites/competitor_selector.js');